import { useEffect, useState } from "react";
import { BsArrowUp } from "react-icons/bs";

import AboutContent from "../components/AboutContent";
import AboutDetails from "../components/AboutDetails";
import AboutOverview from "../components/AboutOverview";
import AboutTeam from "../components/AboutTeam";
import Footer from '../components/Footer'
const About = () => {
    const [visible, setVisible] = useState(false);

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 200) {
      setVisible(true);
    } else if (scrolled <= 200) {
      setVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  window.addEventListener("scroll", toggleVisible);
  useEffect(() => {
    const scrolled = document.documentElement.scrollTop;
    if(scrolled > 0){
      scrollToTop()
    }
  }, [])
  return (
    <div className="overflow-hidden">
      <AboutContent />
      <AboutOverview />
      <AboutDetails />
      <AboutTeam />
      <Footer />
      <div>
        {visible && (
          <div
            className="cursor-pointer bg-gradient-to-tr from-[#FE4904] to-[#F7164C] fixed bottom-10 right-10 w-[40px] h-[40px] flex items-center justify-center rounded-lg hover:from-[#F7164C] hover:to-[#FE4904]"
            onClick={scrollToTop}
          >
            <BsArrowUp color="white" size='24px' />
          </div>
        )}
      </div>
    </div>
  );
};
export default About;
